import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { useFormikContext } from 'formik'
import AttributesList from '../../../../components/Form/Attributes/AttributesList'
import { AttributeContextType, AttributesReturnProps, AttributeViewType, EntityAttributeType } from '../../../../hooks/useAttributes'
import useViewport, { Viewport } from '../../../../hooks/useViewport'

type Props = {
    attributes: AttributesReturnProps
    context: AttributeContextType[]
}

/**
 * Kenmerken (attributes) of a party — only shown when the Attributes module is active and there are
 * active definitions or already-set values.
 */
export default function AttributesSection(props: Props): ReactElement {
    const { values, setFieldValue } = useFormikContext<any>()
    const { isViewport, viewport } = useViewport()
    const orientation = useMemo(() => (isViewport('>=', Viewport.MainMenu) ? 'horizontal' : 'vertical'), [viewport])

    return (
        <AttributesList
            attributeDefinitions={props.attributes.attributeDefinitions}
            entityType={EntityAttributeType.Party}
            context={props.context}
            viewType={AttributeViewType.Input}
            orientation={orientation}
            entity={values}
            entityId={values.id}
            setFieldValue={setFieldValue}
        />
    )
}
